import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { clearAutocomplete, searchUsers } from "../api/autocompleteapi";
import { getAutoCompleteUsersList, getAutoCompleteUsersLoading } from "../selector/selectors";
import { openAccessCodeDialog } from "../state/accesscode/actions";

const AutoCompleteComponent = ({ value, onChange }) => {
    const dispatch    = useDispatch();
    const users       = useSelector(getAutoCompleteUsersList);
    const loading     = useSelector(getAutoCompleteUsersLoading);
    
    const handleInputChange = (_, inputValue, reason) => {
        if (reason === "clear" || inputValue.trim() === "") {
            dispatch(clearAutocomplete());
            return;
        }
        dispatch(searchUsers(inputValue));
    };

   const handleDialogBox = (newValue) => {
        if(!newValue?.login && newValue !== null){
            document.activeElement.blur(); 
            dispatch(openAccessCodeDialog());
        }
    }
    return (
        <Autocomplete
            value={value}
            options={users}
            loading={loading}
            getOptionLabel={(option) => option.email || ""}
            onChange={(_, newValue) => {
                onChange(newValue);
                handleDialogBox(newValue);
            }}
            isOptionEqualToValue={(option, val) => option.email === val.email}
            onInputChange={handleInputChange}
            clearOnEscape
            renderInput={(params) => (
                <TextField
                    {...params}
                    // label="Search User"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && <CircularProgress size={18} />}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

export default AutoCompleteComponent;
